const ButtonCopy = {

    init() {
        this.el = $('[element="button"].copy, button.copy, .button.copy');
        if (!this.el.length) return;

        this.bind();
    },

    bind() {

        this.el.click((evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            const el = $(evt.currentTarget);
            let text;

            if (el.attr('result') === 'html') {
                let temp = el.parent().clone(false, false).appendTo(el.parent());
                temp.removeClass('filled');
                temp.find('button.copy').remove();
                temp.find('[data-cip-id]').removeAttr('data-cip-id');
                temp.find('[valid]').removeAttr('valid');
                temp.find('.valid').removeClass('valid');
                text = temp.prop("outerHTML");
                temp.remove();
            } else {
                text = el.parent().text();
            }

            navigator.clipboard.writeText(text.trim()).then(r => {
                setTimeout(() => {
                    el.attr('icon', 'check').addClass('done');
                }, 100)

                setTimeout(() => {
                    el.attr('icon', 'content_copy').removeClass('done');
                }, 1500)
            });
        })
    },
};

export default ButtonCopy;